var __defProp = Object.defineProperty;
var __markAsModule = (target) => __defProp(target, "__esModule", { value: true });
var __export = (target, all) => {
  __markAsModule(target);
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
__export(exports, {
  concatMultipleOperands: () => concatMultipleOperands
});
const concatMultipleOperands = (...operands) => {
  const allOperands = operands.reduce((acc, next) => {
    if (next !== void 0 && next !== null && next !== "") {
      return acc.concat(next);
    }
    return acc;
  }, []);
  return allOperands;
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  concatMultipleOperands
});
